/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import { ENUM_STATUS_GAME } from "constants"

import React, { useState, useEffect, useRef, useMemo } from "react"

import CustomButton from "components/CustomButton"
import { fabric } from "fabric"
import useEventListener from "hooks/useEventListener"
import { getTextByShadow, loadImage } from "utils"

import Title from "../common/Title"

const TIME_INTERVAL = 30 // seconds

const RestTimeNoti = () => {
    const [restTime, setRestTime] = useState(TIME_INTERVAL)

    useEffect(() => {
        const interval = setInterval(() => {
            setRestTime((prev) => prev - 1)
        }, 1e3)

        return () => {
            clearInterval(interval)
        }
    }, [])

    return (
        <p className="text-quinary text-sm italic font-normal mt-8 tablet:mt-10">
            (*) Nếu bạn yêu chưa nặn bóng , hệ thống sẽ tự động nặn bóng và đọ điểm giúp bạn yêu
            trong vòng { restTime } giây nữa
        </p>
    )
}

const GetShadow = ({ seri, setStatus, shadow }) => {
    const canvasWrapperRef = useRef(null)

    const [canvas, setCanvas] = useState(false)

    const handleReady = async() => {
        setStatus(ENUM_STATUS_GAME.GET_RESULTS)
    }

    useEffect(() => {
        const drawCanvas = async() => {
            const tempCanvas = new fabric.Canvas("canvas", {
                preserveObjectStacking : true,
                selection              : false,
                defaultCursor          : "default",
                backgroundColor        : "#ffffff",
                imageSmoothingEnabled  : false,
                controlsAboveOverlay   : true,
                includeDefaultValues   : true
            })

            const viewEl = canvasWrapperRef.current

            const img = await loadImage(
                "https://firebasestorage.googleapis.com/v0/b/daudit-145c2.appspot.com/o/dolla_show.jpg?alt=media&token=8414e097-4f4d-45b5-bb09-f253f0c6eede"
            )
            const imgW = img.width
            const imgH = img.height

            const ratio = viewEl.clientWidth / imgW

            tempCanvas.setDimensions({
                width  : imgW * ratio,
                height : imgH * ratio
            })

            const backgroundImg = new fabric.Image(img)

            await tempCanvas.setBackgroundImage(
                backgroundImg,
                tempCanvas.renderAll.bind(tempCanvas),
                {
                    top     : 0,
                    left    : 0,
                    originX : "left",
                    originY : "top",
                    scaleX  : ratio,
                    scaleY  : ratio
                }
            )

            const canvasW = imgW * ratio
            const canvasH = imgH * ratio

            const textObj = new fabric.Text(`PO ${seri}`.split("").join(String.fromCharCode(8202)) , {
                left       : canvasW * 0.468,
                top        : canvasH * 0.64,
                fill       : "black",
                editable   : false,
                originX    : "left",
                originY    : "top",
                fontSize   : 25 * ratio,
                fontFamily : "Arial",
                hasBorders : false

            })

            textObj.setControlsVisibility({
                mt  : !true,
                mb  : !true,
                ml  : !true,
                mr  : !true,
                bl  : !true,
                br  : !true,
                tl  : !true,
                tr  : !true,
                mtr : !true
            })

            textObj.lockMovementX = true
            textObj.lockMovementY = true
            tempCanvas.add(textObj)

            const rect = new fabric.Rect({
                left        : canvasW * 0.462,
                top         : canvasH * 0.64,
                width       : canvasW * 0.31,
                height      : canvasH * 0.08,
                hasBorders  : false,
                hasControls : false
            })
            tempCanvas.add(rect)

            tempCanvas.renderAll()
            setCanvas(tempCanvas)
        }
        drawCanvas()
    }, [])

    useEventListener("resize", () => {
        if (!canvas){
            return
        }

        const viewEl = canvasWrapperRef.current
        if (!viewEl){
            return
        }
        const ratio = canvas.getWidth() / canvas.getHeight()
        const containerWidth = viewEl.clientWidth
        const scale = containerWidth / canvas.getWidth()
        const zoom = canvas.getZoom() * scale

        canvas.setDimensions({ width: containerWidth, height: containerWidth / ratio })
        canvas.setViewportTransform([zoom, 0, 0, zoom, 0, 0])
        canvas.setZoom(zoom)
        canvas.calcOffset()
    })

    useEffect(() => {
        const timeout = setTimeout(() => {
            handleReady()
        }, TIME_INTERVAL * 1000)

        return () => {
            clearTimeout(timeout)
        }
    }, [])

    const textShadow = useMemo(() => {
        return getTextByShadow(shadow)
    }, [])

    return (
        <div>
            <Title>2. Nặn bóng</Title>

            <p className="text-lg font-semibold tracking-wide text-center">Bóng: { textShadow }</p>

            <div className="mt-2 tablet:mt-4" ref={ canvasWrapperRef }>
                <canvas height={ 0 } id="canvas" width={ 0 } />
            </div>

            <p className="text-quinary text-sm italic font-normal mt-1 text-center">
                Kéo thả ô màu đen để xem seri tiền
            </p>

            <RestTimeNoti />

            <CustomButton className="w-full h-[44px] mt-4" onClick={ handleReady }>
                Đọ điểm
            </CustomButton>
        </div>
    )
}

export default GetShadow
